import { useCallback } from 'react';
import { FormData } from '~/training/sequence/templates/items/chatBot/components/forms/AIScenarioForm';

interface UseFormSubmissionProps {
  onSubmit: (data: FormData) => Promise<void> | void;
  onClose?: () => void;
  closeOnSubmit?: boolean;
}

export const useFormSubmission = ({
  onSubmit,
  onClose,
  closeOnSubmit = true
}: UseFormSubmissionProps) => {
  const handleSubmit = useCallback(
    async (event: React.FormEvent, formData?: FormData) => {
      event.preventDefault();

      if (formData) {
        await onSubmit(formData);
      }

      if (closeOnSubmit && onClose) {
        onClose();
      }
    },
    [onSubmit, onClose, closeOnSubmit]
  );

  return { handleSubmit };
};
